import { render, staticRenderFns } from "./CxToastCard.vue?vue&type=template&id=7b6a0cdf&scoped=true"
import script from "./CxToastCard.vue?vue&type=script&lang=js"
export * from "./CxToastCard.vue?vue&type=script&lang=js"
import style0 from "./CxToastCard.vue?vue&type=style&index=0&id=7b6a0cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a0cdf",
  null
  
)

export default component.exports